module.exports = __webpack_public_path__ + "img/female.cffe822a.svg";